import { date } from 'quasar'
import columnsValues from '@/HTable/columnsValues'

export default {
  data () {
    return {
      columns: [
        {
          label: 'ID',
          field: 'id',
          name: 'id',
          filter: '',
          align: 'left',
          type: 'text',
        },
        {
          label: 'Проект',
          field: 'name',
          name: 'name',
          sortable: true,
          filter: '',
          align: 'left',
          type: 'text',
        },
        {
          label: 'Клиент',
          field: 'owner',
          name: 'owner_id',
          filter: [],
          sortable: true,
          align: 'left',
          type: 'value',
          searchRequest: (query) => {
            return new Promise((resolve, reject) => {
              this.$http.get(
                `api/v1.0/users/?filter[role]=user&filter[search]=${query}&perPage=60`).
                then(response => {
                  const users = response.data.users.map(row => {
                    return {
                      value: row.id,
                      label: `${row.first_name} ${row.last_name}`,
                    }
                  })
                  resolve(users)
                }).
                catch(error => {
                  reject(error)
                })
            })
          },
          values: (col) => {
            return new Promise((resolve, reject) => {
              let filter = col.filter.map(val => `filter[id][]=${val}`).
                join('&')

              this.$http.get(`api/v1.0/users/?${filter}`).then(response => {
                const values = response.data.users.map(user => {
                  return {
                    value: user.id,
                    label: `${user.first_name} ${user.last_name}`,
                  }
                }).concat(col.defaultValues)
                resolve(values)
              }).catch(error => {
                reject(error)
              })
            })

          },
          defaultValues: [
            {
              value: 'null',
              label: `Не задан`,
            },
          ],
          format: value => value
            ? `${value.first_name} ${value.last_name}`
            : '',
        },
        {
          label: 'Менеджер',
          field: 'manager',
          name: 'manager',
          filter: [],
          align: 'left',
          type: 'value',
          values: [],
          format: value => value
            ? `${value.first_name} ${value.last_name}`
            : '',
        },
        {
          label: 'Сайт',
          name: 'domain',
          field: 'domains',
          align: 'left',
          type: 'text',
          filter: '',
          format: value => {
            return this.getDomain(value)
          },
        },
        {
          label: 'Кастом',
          field: 'has_custom',
          name: 'has_custom',
          filter: [],
          align: 'left',
          type: 'bool',
          format: value => {
            return value ? 'Да' : 'Нет'
          },
        },
        {
          label: 'SSL',
          field: 'ssl',
          name: 'ssl',
          filter: [],
          align: 'left',
          type: 'bool',
          format: value => {
            return value ? 'Да' : 'Нет'
          },
        },
        {
          label: 'Сервис код',
          field: 'service_code',
          name: 'service_code',
          filter: '',
          align: 'left',
          type: 'text',
        },
        {
          label: 'Дата создания',
          field: 'created_at',
          name: 'created_at',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'date',
          format: value => {
            return date.formatDate(value, 'YYYY-MM-DD')
          },
        },
        {
          label: 'Дата обновления',
          field: 'updated_at',
          name: 'updated_at',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'date',
          format: value => {
            return date.formatDate(value, 'YYYY-MM-DD')
          },
        },
        {
          label: 'Теги',
          field: 'tags',
          name: 'tags',
          filter: [],
          align: 'left',
          type: 'value',
          values: [],
        },
        {
          label: 'Тип размещения',
          field: 'prod_location',
          name: 'prod_location',
          sortable: true,
          filter: [],
          align: 'left',
          type: 'value',
          values: columnsValues.locations,
          format: val => {
            return this.formatValue(val, 'prod_location')
          },
        },
        {
          label: 'Статус',
          field: 'status',
          name: 'status',
          sortable: true,
          filter: [],
          align: 'left',
          type: 'value',
          values: columnsValues.statuses,
          format: val => {
            return this.formatValue(val, 'status')
          },
        },
        {
          label: 'Тариф',
          field: 'service',
          name: 'service_id',
          sortable: true,
          filter: [],
          align: 'left',
          type: 'value',
          values: [
            {
              value: 'null',
              label: `Не задан`,
            },
            ...columnsValues.services,
          ],
          format: value => {
            return value && this.formatValue(value.service.name, 'service')
          },
        },
        {
          label: 'Дата окончания тарифа',
          field: 'additional',
          name: 'payment_plan_valid_until',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'date',
          format: value => {
            return date.formatDate(value.payment_plan_valid_until,
              'YYYY-MM-DD')
          },
        },
        {
          label: 'Количество товаров',
          field: 'additional',
          name: 'products_count',
          sortable: true,
          filter: {},
          align: 'right',
          type: 'int',
          format: value => {
            return value.products_count
          },
        },
        {
          label: 'Количество заказов',
          field: 'additional',
          name: 'orders_count',
          sortable: true,
          filter: {},
          align: 'right',
          type: 'int',
          format: value => {
            return value.orders_count
          },
        },
        {
          label: 'Неоплаченные счета',
          field: 'additional',
          name: 'unpaid_bills_count',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'int',
          format: value => {
            return value.unpaid_bills_count
          },
        },
        {
          label: 'Долг по неоплаченным счетам',
          field: 'additional',
          name: 'unpaid_bills_debt',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'int',
          format: value => {
            return this.formatNumber(value.unpaid_bills_debt, 1 / 100)
          },
        },
        {
          label: 'Платящий клиент',
          field: row => row.states.paying_customer !== undefined
            ? row.states.paying_customer.value
            : null,
          name: 'state.paying_customer',
          sortable: false,
          filter: [],
          align: 'left',
          type: 'value',
          values: [
            {
              value: 0,
              label: 'Нет',
            },
            {
              value: 1,
              label: 'Да',
            },
          ],
          onlyOneFilter: true,
          search: function (query, routeQuery) {
            const filterStr = 'filter[state][paying_customer]'

            return [
              query +
              this.filter.map(item => `${filterStr}=${item}`).join('&'),
              { ...routeQuery, ...{ [filterStr]: this.filter } },
            ]
          },
          format: val => {
            if (val === null) {
              return 'Не определено'
            }

            return val ? 'Да' : 'Нет'
          },
        },
        {
          label: 'Поставщик услуг',
          field: 'service_provider_alias',
          name: 'service_provider_id',
          sortable: false,
          filter: [],
          align: 'left',
          type: 'value',
          values: [],
        },
        {
          label: 'Название компании',
          field: row => {
            return row.payment_data.company_name
          },
          name: 'company_name',
          sortable: false,
          filter: [],
          align: 'left',
          type: 'text',
          values: [],
        },
        {
          label: 'ЕГРПОУ',
          field: 'edrpou',
          name: 'edrpou',
          sortable: false,
          filter: [],
          align: 'left',
          type: 'text',
          values: [],
        },
        {
          label: 'Регион',
          field: 'region',
          name: 'region',
          sortable: false,
          filter: [],
          align: 'left',
          type: 'value',
          values: columnsValues.regions,
        },
      ],
    }
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/ProjectsList/mixins/columns.js